import React from "react";

const Footer = () => {
    return (
        <div className="footer" id="ContactUs">
            <div className="d-flex items justify-content-around">
                <div className="footer-item">
                    <p>موقعیت</p>
                    <span>
                        دفتر تهران: بزرگراه جلال ال احمد- بین خیابان کارگر واتوبان چمران -کوی پروانه- پلاک2واحد1
                    </span>
                    <br />
                    <br />
                    <br />
                    <span>
                        دفتر اصفهان:میدان احمد اباد -ابتدای خیابان شهید مفتح -ساختمان امام رضا (ع)
                    </span>
                </div>
                <div className="footer-item">
                    <p>شماره های تماس</p>
                    <p className="phone-number">(031)-322 74 792-3</p>
                    <p className="phone-number">(021)-880 19 129</p>
                    <p className="phone-number">0930 163 8346</p>
                </div>
                <div className="footer-item" >
                    <p>نماد</p>
                    {/* <a
                        referrerpolicy="origin"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=28895&Code=NRjTpo5XWTRAnoA3535f">
                        <img referrerpolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=28895&Code=NRjTpo5XWTRAnoA3535f" alt="" id="NRjTpo5XWTRAnoA3535f" /></a> */}
                </div>
            </div>
            <div className="footer-border"></div>
            <div className="copyright text-center">
                تمام حقوق مادی و معنوی وبسایت محفوظ میباشد
            </div>
        </div>
    );
};

export default Footer;
